import api from 'service/api'

const dponetAPI = api.create('dponet')

const generateKey = async () => {
  return await dponetAPI.get('/moodle/generate_key')
}

export default { generateKey }
